import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { addStoryRoute, signinRoute } from "../../../routes/routesPath";

export default function HeroSection() {
  const { isAuthenticated } = useAuth();

  return (
    <Row className="homeBanner d-flex m-0 px-3 px-lg-5">
      <Col lg={8} md={7} className="d-flex align-items-center justify-content-center">
        <div className="px-sm-5 mt-5 mt-lg-0">
          <h1 className="fw-normal h3 mb-3">
            Are you <span className="fw-sbold text-secondary">Stressed? </span>
            <br />
            or Looking for Someone to share your{" "}
            <span className="fw-sbold text-secondary">Feelings?</span>
            <br />
            <Link
              className="pointer fw-bold text-primary text-decoration-underline"
              to={isAuthenticated ? addStoryRoute : signinRoute}>
              Join Us now
            </Link>
          </h1>
          <p className="bannerDesc">
            Feelinghub is a unique platform where you can share your feelings, emotions, and
            problems with others. You can also share anonymously or save as private for you. Receive
            support from our community or our admin team. Explore our programs and sign up now!
          </p>
        </div>
      </Col>
      <Col lg={4} md={5} className="h-100 text-center">
        <img
          src="/images/homeBanner.webp"
          alt="Feelinghub Support"
          fetchPriority="high"
          className="max-h-350 img-fluid"
          loading="eager"
        />
      </Col>
    </Row>
  );
}
